var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.message.error)?_c('div',{staticClass:"loading"},[_vm._v("กรุณารอสักครู่ ....")]):_c('div',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.message.text))]),_c('div',{staticClass:"redirect",on:{"click":_vm.redirect}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('small',[_c('u',[_vm._v("คลิกหากไม่มีอะไรเกิดขึน")])])
}]

export { render, staticRenderFns }